import PropTypes from 'prop-types';

import ButtonBase from './ButtonBase';

const typeStyles = {
  danger: 'button-danger',
  primary: 'button-primary',
  'primary-alternate': 'button-primary-alternate',
  secondary: 'button-secondary',
  subtle: 'button-subtle',
  tertiary: 'button-tertiary',
  warning: 'button-warning',
};

const Button = ({ children, type, ...rest }) => (
  <ButtonBase className={typeStyles[type] || ''} {...rest}>
    {children}
  </ButtonBase>
);

Button.defaultProps = {
  disabled: false,
  isLoading: false,
  isSubmit: false,
  type: 'secondary',
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSubmit: PropTypes.bool,
  type: PropTypes.oneOf([
    'danger',
    'primary',
    'primary-alternate',
    'secondary',
    'subtle',
    'tertiary',
    'warning',
  ]),
};

export default Button;
